import React from "react";
import { Col, Row } from "react-bootstrap";

const EmploymentInfo = ({ data }) => {
  return (
    <div>
      <section className="view-data">
        <Row className="main-view-email pt-3">
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Employer:</strong>
              {data?.employer || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Length of job:</strong>
              {data?.length_of_job || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Employer Address:</strong>
              {data?.employer_address || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Occupation:</strong>
              {data?.occupation || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Pay Period:</strong>
              {data?.pay_period || "--"}
            </div>
          </Col>
          <Col md={12}>
            <h5 className="mb-3">Spouse Info:</h5>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Employer:</strong>
              {data?.for_spouse?.employer || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Length of job:</strong>
              {data?.for_spouse?.length_of_job || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Employer Address:</strong>
              {data?.for_spouse?.employer_address || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Occupation:</strong>
              {data?.for_spouse?.occupation || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Pay Period:</strong>
              {data?.for_spouse?.pay_period || "--"}
            </div>
          </Col>
        </Row>
      </section>
    </div>
  );
};

export default EmploymentInfo;
